import './styles.css';
import searchIcon from './images/search-icon.svg';
import closeIcon from './images/close-icon.svg';
import escape from 'lodash.escape';
const modalView = ({ searchPlaceholder }) => `
  <div class="link-modal-overlay">
    <div class="link-modal">
      <div class="link-modal__search">
        <div class="link-modal__search-field">
          <div class="link-modal__search-icon">${searchIcon}</div>
          <input type="text" class="link-modal__search-input" placeholder="${searchPlaceholder || 'Publication title'}..." autofocus />
        </div>

        <div class="link-modal__close">${closeIcon}</div>
      </div>

      <div class="link-modal__publications"></div>

      <div class="link-modal__footer">
        <div class="link-modal__footer-message">Press Esc to exit</div>
      </div>
    </div>
  </div>
`;
const publicationItem = (item) => {
    const label = (item.linkType.charAt(0).toUpperCase() + item.linkType.slice(1))
        .split('-')
        .join(' ');
    let subTitle = item.subTitle !== undefined ? item.subTitle : 'Static page';
    if (item.id) {
        subTitle = `${escape(label)} · id: ${escape(item.id)}`;
    }
    return `
    <div class="link-modal__publication">
      <div class="link-modal__publication-title">${escape(item.title)}</div>
      <div class="link-modal__publication-id">
      ${subTitle}
      </div>
    </div>
  `;
};
class LinkModal {
    constructor(publications, modalViewParams) {
        this.publications = publications;
        this.modalView = modalView(modalViewParams || {});
    }
    handleCloseClick(e) {
        e.stopPropagation();
        this.hide();
        this.onClose();
    }
    handleItemClick(publication) {
        this.onSelect({ ...publication, publicationId: publication.id });
        this.hide();
    }
    handleTextFieldChange(e) {
        const value = e.target && e.target.value && e.target.value.trim().toLowerCase();
        let filteredPublications = this.publications.slice();
        if (!value) {
            this.showPublications(filteredPublications);
            return;
        }
        const publicationsToShow = filteredPublications.filter((publication) => {
            const titleSearchValue = publication.title.toLowerCase().indexOf(value);
            const idSearchValue = publication.id ? publication.id.toString().indexOf(value) : -1;
            return titleSearchValue + idSearchValue > -2;
        });
        this.showPublications(publicationsToShow);
    }
    handleEscapeClick(e) {
        if (e.code === 'Escape')
            this.handleCloseClick(e);
    }
    handleSearchAreaClick(e) {
        this.textField.focus();
    }
    hidePublications() {
        this.publicationsContainer.classList.remove('is-visible');
        this.publicationsContainer.innerHTML = '';
    }
    showPublications(publications) {
        if (!publications.length) {
            this.hidePublications();
            return;
        }
        this.publicationsContainer.classList.add('is-visible');
        this.publicationsContainer.innerHTML = '';
        publications.forEach((publication) => {
            this.publicationsContainer.insertAdjacentHTML('beforeend', publicationItem(publication));
            const items = document.querySelectorAll('.link-modal__publication');
            items[items.length - 1].addEventListener('click', () => {
                this.handleItemClick(publication);
            });
        });
    }
    hide() {
        this.removeHandlers();
        document.body.removeChild(this.modalContainer);
        document.body.style.overflowY = 'auto';
    }
    show() {
        document.body.insertAdjacentHTML('afterbegin', this.modalView);
        document.body.style.overflowY = 'hidden';
        this.closeButton = document.querySelector('.link-modal__close');
        this.textField = document.querySelector('.link-modal__search-input');
        this.searchAreaContainer = document.querySelector('.link-modal__search');
        this.publicationsContainer = document.querySelector('.link-modal__publications');
        this.modalContainer = document.querySelector('.link-modal-overlay');
        setTimeout(() => this.textField.focus(), 0); // if the text is selected in the editor autofocus doesn't work
        this.addHandlers();
        this.showPublications(this.publications);
        return new Promise((resolve, reject) => {
            this.onSelect = resolve;
            this.onClose = reject;
        });
    }
    addHandlers() {
        this.searchAreaContainer.addEventListener('click', this.handleSearchAreaClick.bind(this));
        this.textField.addEventListener('keyup', this.handleTextFieldChange.bind(this));
        this.modalContainer.addEventListener('keyup', this.handleEscapeClick.bind(this));
        this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
    }
    removeHandlers() {
        this.searchAreaContainer.removeEventListener('click', this.handleSearchAreaClick.bind(this));
        this.textField.removeEventListener('keyup', this.handleTextFieldChange.bind(this));
        this.modalContainer.removeEventListener('keyup', this.handleEscapeClick.bind(this));
        this.closeButton.removeEventListener('click', this.handleCloseClick.bind(this));
    }
}
export default LinkModal;
